import { useMutation } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { DefaultResponseWithData } from "../models/system";
import { IOfferUpdateQueueResult } from "../models/OfferUpdate";

interface IResetBestOfferBody {
  offerIds: string[];
  percent: number;
  useCategoryThreshold: boolean;
}

interface IUpdateTitlesBody {
  items: { offerId: string; title: string }[];
}

interface IUpdatePoliciesBody {
  offerIds: string[];
  locationKey?: string;
  paymentPolicyId?: string;
  fulfillmentPolicyId?: string;
  returnPolicyId?: string;
}

// Queues background eBay offer updates (reset / title / policy). Per-row status is not fetched here —
// it rides along on the listings query (each row carries its latest status, like batchItem).
export default function useOfferUpdate() {
  const { post } = useApiHelper();

  const resetBestOffer = useMutation((body: IResetBestOfferBody) =>
    post<IResetBestOfferBody, DefaultResponseWithData<IOfferUpdateQueueResult>>(
      "/offerupdate/reset-best-offer",
      body
    )
  );

  const updateTitles = useMutation((body: IUpdateTitlesBody) =>
    post<IUpdateTitlesBody, DefaultResponseWithData<IOfferUpdateQueueResult>>(
      "/offerupdate/update-titles",
      body
    )
  );

  const updatePolicies = useMutation((body: IUpdatePoliciesBody) =>
    post<IUpdatePoliciesBody, DefaultResponseWithData<IOfferUpdateQueueResult>>(
      "/offerupdate/update-policies",
      body
    )
  );

  return {
    resetBestOffer,
    updateTitles,
    updatePolicies,
  };
}
